import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import { MEMBERSHIP_GROUP_MEMBER_ACCESS_LEVEL, type MembershipGroupMember } from 'src/features/memberships/types';
import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { GeneralMixedError } from 'src/types';

const RESOURCE = '/parkings/:parkingId/membership-groups/:membershipGroupId/members/:membershipMemberId/';

type FormSchemaValues = z.infer<typeof formSchema>;
const formSchema = z.object({
    access_level: z.nativeEnum(MEMBERSHIP_GROUP_MEMBER_ACCESS_LEVEL),
});

interface DTO extends FormSchemaValues {
    parkingId: string;
    membershipGroupId: number;
    membershipMemberId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({
    parkingId,
    membershipGroupId,
    membershipMemberId,
    ...data
}: DTO): Promise<MembershipGroupMember> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, membershipGroupId, membershipMemberId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralMixedError<FormSchemaValues>> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export {
    RESOURCE as UPDATE_MEMBERSHIP_GROUP_MEMBER_RESOURCE,
    useMutationHook as useUpdateMembershipGroupMember,
    formSchema as updateMembershipGroupMemberFormSchema,
};
export type { DTO as UpdateMembershipGroupMemberDTO, FormSchemaValues as UpdateMembershipGroupMemberFormSchemaValues };
